var map = {
	"./AAVE.png": 252,
	"./AAVE.svg": 477,
	"./ADA.svg": 478,
	"./ANY.png": 253,
	"./ATOM.png": 254,
	"./AVAX.png": 255,
	"./BAKE.png": 256,
	"./BANANA.svg": 479,
	"./BCH.svg": 480,
	"./BDO.png": 257,
	"./BDS.png": 258,
	"./BECO.png": 259,
	"./BETH.png": 260,
	"./BHC.png": 261,
	"./BIFI.png": 262,
	"./BLK.png": 263,
	"./BNB.png": 264,
	"./BORING.png": 265,
	"./BTCB.svg": 481,
	"./BTD.png": 266,
	"./BTS.png": 267,
	"./BUNNY.png": 268,
	"./BURGER.png": 269,
	"./BUSD.png": 270,
	"./BUSD.svg": 482,
	"./CAKE.svg": 349,
	"./CTK.png": 271,
	"./DAI.svg": 483,
	"./DFL.png": 272,
	"./DG.png": 273,
	"./DNFT.png": 274,
	"./DOT.png": 275,
	"./DPET.png": 276,
	"./DRAGON.png": 277,
	"./DRUGS.png": 278,
	"./ETH.png": 279,
	"./ETH.svg": 484,
	"./FAM.png": 280,
	"./FFF.png": 281,
	"./FIL.svg": 485,
	"./FISH.svg": 486,
	"./FTM.png": 282,
	"./HAI.png": 283,
	"./HARD.png": 284,
	"./HBTC.png": 285,
	"./HPS.png": 286,
	"./HT.png": 287,
	"./HTB.svg": 487,
	"./HUSD.png": 288,
	"./ICA.svg": 488,
	"./INCH.png": 289,
	"./INJ.png": 290,
	"./JETS.png": 291,
	"./JULD.png": 292,
	"./KABA.png": 293,
	"./KAI.png": 294,
	"./KDX.png": 295,
	"./KEBAB.png": 296,
	"./KPHI.png": 297,
	"./KSC.png": 298,
	"./KUSD.png": 299,
	"./LINK.png": 300,
	"./LPDI.png": 301,
	"./LTC.svg": 489,
	"./LTD.png": 302,
	"./MARSH.png": 303,
	"./MATIC.png": 304,
	"./MATIC.svg": 490,
	"./MDX.png": 305,
	"./MERL.svg": 491,
	"./MOWA.png": 306,
	"./MSC.png": 307,
	"./MSS.png": 308,
	"./NUTS.png": 309,
	"./NYA.png": 310,
	"./NYAC.png": 311,
	"./NYAS.png": 312,
	"./O3.png": 313,
	"./PBNB.png": 314,
	"./PMP.svg": 492,
	"./POLYGON.png": 315,
	"./PUP.png": 316,
	"./PolyDoge.png": 317,
	"./QUICK.png": 318,
	"./RABBIT.svg": 493,
	"./RAMP.png": 319,
	"./SBDO.png": 320,
	"./SEN.png": 321,
	"./SFP.png": 322,
	"./SMART.png": 323,
	"./SNX.png": 324,
	"./SOAK.png": 325,
	"./SPIRIT.png": 326,
	"./STEEL.png": 327,
	"./SUSHI.png": 328,
	"./SWAMP.svg": 494,
	"./SXP.svg": 495,
	"./TENFI.png": 329,
	"./THG.png": 330,
	"./TPH.png": 331,
	"./TYPH.png": 332,
	"./UNI.png": 333,
	"./USDC.png": 334,
	"./USDC.svg": 496,
	"./USDT.png": 335,
	"./USDT.svg": 497,
	"./VNDC.webp": 498,
	"./WAULTx.svg": 499,
	"./WBNB.svg": 500,
	"./WBTC.png": 336,
	"./WBTC.svg": 501,
	"./WEX.svg": 502,
	"./WOO.svg": 503,
	"./WOOFY.png": 337,
	"./XRP.svg": 504,
	"./XTZ.png": 338,
	"./XVS.png": 339,
	"./YELD.png": 340,
	"./YFI.png": 341,
	"./ZBTC.svg": 505,
	"./ZETH.svg": 506,
	"./cakeHARD.png": 342,
	"./cakeROOBEE.png": 343,
	"./cakeSTAX.png": 344,
	"./cakeTWT.png": 345,
	"./cakebROOBEE.png": 346,
	"./fUSDT.png": 347,
	"./ibBTC.svg": 507,
	"./miMATIC.png": 348,
	"./rUSD.svg": 508,
	"./sALPACA.svg": 509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 946;